import ApprovalContent from "./Content";
import ApprovalSummary from "./Summary";

export const ApprovalStep = {
  Content: ApprovalContent,
  Summary: ApprovalSummary
}